import { Injectable, inject } from '@angular/core';
import { DevicesRouterStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { DeviceAssignmentHistoryStoreActions } from './device-assignment-history-store';

@Injectable({ providedIn: 'root' })
export class DeviceAssignmentHistoryResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        if (!udid) {
          return;
        }

        this.store.dispatch(
          DeviceAssignmentHistoryStoreActions.DeviceAssignmentHistoryResolverActions.historyRequested({ udid })
        );
      }),
      map(() => true),
      first()
    );
  }
}
